import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestPresetsBannerGet = {
    path: "/presets/banner",
    method: RouteHttpVerb.GET
};
